import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "menu"
};
const _hoisted_3 = ["onClick", "onMouseover", "onMousemove"];
const _hoisted_4 = {
  class: "login-btn"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "登录", -1);
const _hoisted_6 = {
  class: "pop"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "left"
};
const _hoisted_9 = {
  class: "left-cpntainer"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "平台简介", -1);
const _hoisted_11 = {
  class: "desc"
};
const _hoisted_12 = {
  class: "right"
};
const _hoisted_13 = {
  class: "right-container"
};
const _hoisted_14 = {
  class: "list software-list"
};
const _hoisted_15 = ["onMouseover", "onClick"];
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left-cpntainer"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "解决方案简介"), /*#__PURE__*/_createElementVNode("p", {
  class: "desc"
}, " 微星物联行业解决方案可应用在水利监测、海洋监测、应急求生、畜牧监测、煤矿监测、地质灾害监测、应急指挥和公共安全等行业领域。 ")])], -1);
const _hoisted_17 = {
  class: "right"
};
const _hoisted_18 = {
  class: "right-container"
};
const _hoisted_19 = {
  class: "list product"
};
const _hoisted_20 = {
  class: "list"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left-cpntainer"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "成功案例简介"), /*#__PURE__*/_createElementVNode("p", {
  class: "desc"
}, " 微星物联行业解决方案已成功应用于畜牧监测、地震监测、煤矿监测等行业领域。 ")])], -1);
const _hoisted_23 = {
  class: "right"
};
const _hoisted_24 = {
  class: "right-container"
};
const _hoisted_25 = {
  class: "list product"
};
const _hoisted_26 = {
  class: "list"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left-cpntainer"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "软件开发简介"), /*#__PURE__*/_createElementVNode("p", {
  class: "desc"
}, " 微星物联软件产品旨在为智慧农业、智慧牧业、灾害预警等解决方案提供配套软件服务，包括智慧大屏、小程序等。 ")])], -1);
const _hoisted_29 = {
  class: "right"
};
const _hoisted_30 = {
  class: "right-container"
};
const _hoisted_31 = {
  class: "list product"
};
const _hoisted_32 = {
  class: "list"
};
const _hoisted_33 = ["onClick"];
import { ref, onMounted, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import solutionData from '@/data/solution';
import casesData from '@/data/cases';
import softwareData from '@/data/software';
import serviceData from '@/data/service';
import { transformMap2List } from '@/utils';
import productData from '@/views/device-detail/data/product';
// 处理一下
export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  setup(__props) {
    const series = [{
      name: '网关产品',
      idList: [0, 1]
    }, {
      name: '模组产品',
      idList: [2]
    }, {
      name: '自组网产品',
      idList: [3, 4, 5, 6, 7, 8, 9, 10]
    }];
    const productD = productData;
    const productList = series.map(item => {
      const list = item.idList.map(id => {
        var _productD$id, _productD$id$section;
        return {
          name: ((_productD$id = productD[id]) === null || _productD$id === void 0 ? void 0 : (_productD$id$section = _productD$id.section2) === null || _productD$id$section === void 0 ? void 0 : _productD$id$section.headerTitle) || '',
          id
        };
      });
      return {
        ...item,
        list
      };
    });
    const solutionList = transformMap2List(solutionData);
    const casesList = transformMap2List(casesData);
    const serviceList = transformMap2List(serviceData);
    // 排序  为了对齐好看
    const sortIds = ['0', '1', '3', '2'];
    const softwareList = sortIds.map(id => {
      return {
        ...softwareData[id],
        id
      };
    });
    const navList = [{
      title: '首页',
      path: '/',
      name: 'home'
    }, {
      title: '解决方案',
      path: '/solution',
      name: 'solution'
    }, {
      title: '成功案例',
      path: '/cases',
      name: 'cases'
    },
    // {
    //   title: '产品中心',
    //   path: '/device-detail',
    //   name: 'device-detail',
    //   disabled: true,
    // },
    {
      title: '平台服务',
      path: '/software',
      name: 'software'
    }, {
      title: '软件开发',
      path: '/service',
      name: 'service'
    }, {
      title: '新闻中心',
      path: '/news-list',
      name: 'news-list'
    }, {
      title: '关于我们',
      path: '/about',
      name: 'about'
    }];
    const $route = useRoute();
    const router = useRouter();
    const activeRoute = ref('');
    watch($route, () => {
      const name = $route.name || '';
      navList.forEach(element => {
        if (name.indexOf(element.name) >= 0) {
          activeRoute.value = element.name;
        }
      });
    }, {
      immediate: true
    });
    const toPath = menuData => {
      const {
        path,
        disabled
      } = menuData;
      if (disabled) {
        return;
      }
      router.push(path);
      currentHoverName.value = '';
    };
    const scroll = ref(false);
    onMounted(() => {
      window.addEventListener('scroll', () => {
        scroll.value = (document.body.scrollTop || document.documentElement.scrollTop) !== 0;
      });
      scroll.value = (document.body.scrollTop || document.documentElement.scrollTop) !== 0;
    });
    const currentHoverName = ref('');
    const mouseEvent = name => {
      currentHoverName.value = name;
    };
    const toLink = path => {
      router.push(path);
      currentHoverName.value = '';
    };
    const showPlatform = computed(() => {
      return platformDesc.value || '微信物联平台服务包括了物联网平台、卫星监测平台、遥测数据共享平台和运营平台，可提供符合客户需求的增值服务。';
    });
    const platformDesc = ref('');
    const hoverPlatform = desc => {
      platformDesc.value = desc || '';
    };
    const openLink = ({
      loginUrl
    }) => {
      if (loginUrl) {
        window.open(loginUrl);
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass(["header-wrapper", {
          'header-wrapper-scroll': scroll.value || !!currentHoverName.value
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(navList, (item, index) => {
        return _createElementVNode("span", {
          onClick: $event => toPath(item),
          class: _normalizeClass(["menu-item", {
            'menu-item-active': activeRoute.value === item.name || item.name === currentHoverName.value
          }]),
          key: index,
          onMouseover: $event => mouseEvent(item.name),
          onMousemove: $event => mouseEvent(item.name),
          onMouseleave: _cache[0] || (_cache[0] = $event => mouseEvent(''))
        }, _toDisplayString(item.title), 43, _hoisted_3);
      }), 64))]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(softwareList), (item, index) => {
        return _openBlock(), _createElementBlock("a", {
          onClick: $event => openLink(item),
          key: index
        }, _toDisplayString(item.title), 9, _hoisted_7);
      }), 128))])])])], 2), _createElementVNode("div", {
        class: _normalizeClass(["header-layout", {
          fadeInDown: currentHoverName.value === 'software'
        }]),
        onMouseover: _cache[3] || (_cache[3] = $event => mouseEvent('software')),
        onMouseleave: _cache[4] || (_cache[4] = $event => mouseEvent(''))
      }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(showPlatform)), 1)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = $event => toLink('/software')),
        class: "enter software"
      }, "平台服务"), _createElementVNode("div", _hoisted_14, [_createElementVNode("p", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(softwareList), (item, index) => {
        return _openBlock(), _createElementBlock("a", {
          onMouseover: $event => hoverPlatform(item.headerDesc),
          onMouseleave: _cache[2] || (_cache[2] = $event => hoverPlatform('')),
          onClick: $event => toLink(`/software/${item.id}`),
          key: index
        }, _toDisplayString(item.title), 41, _hoisted_15);
      }), 128))])])])])], 34), _createElementVNode("div", {
        class: _normalizeClass(["header-layout", {
          fadeInDown: currentHoverName.value === 'solution'
        }]),
        onMouseover: _cache[6] || (_cache[6] = $event => mouseEvent('solution')),
        onMouseleave: _cache[7] || (_cache[7] = $event => mouseEvent(''))
      }, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
        onClick: _cache[5] || (_cache[5] = $event => toLink(`/solution`)),
        class: "enter solution"
      }, " 解决方案 "), _createElementVNode("div", _hoisted_20, [_createElementVNode("p", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(solutionList), item => {
        return _openBlock(), _createElementBlock("a", {
          onClick: $event => toLink(`/solution/${item.id}`),
          key: item.id
        }, _toDisplayString(item.title), 9, _hoisted_21);
      }), 128))])])])])])], 34), _createElementVNode("div", {
        class: _normalizeClass(["header-layout", {
          fadeInDown: currentHoverName.value === 'cases'
        }]),
        onMouseover: _cache[9] || (_cache[9] = $event => mouseEvent('cases')),
        onMouseleave: _cache[10] || (_cache[10] = $event => mouseEvent(''))
      }, [_hoisted_22, _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", {
        onClick: _cache[8] || (_cache[8] = $event => toLink(`/cases`)),
        class: "enter cases"
      }, "成功案例"), _createElementVNode("div", _hoisted_26, [_createElementVNode("p", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(casesList), item => {
        return _openBlock(), _createElementBlock("a", {
          onClick: $event => toLink(`/cases/${item.id}`),
          key: item.id
        }, _toDisplayString(item.title), 9, _hoisted_27);
      }), 128))])])])])])], 34), _createElementVNode("div", {
        class: _normalizeClass(["header-layout", {
          fadeInDown: currentHoverName.value === 'service'
        }]),
        onMouseover: _cache[12] || (_cache[12] = $event => mouseEvent('service')),
        onMouseleave: _cache[13] || (_cache[13] = $event => mouseEvent(''))
      }, [_hoisted_28, _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", {
        onClick: _cache[11] || (_cache[11] = $event => toLink(`/service`)),
        class: "enter service"
      }, "业务简介"), _createElementVNode("div", _hoisted_32, [_createElementVNode("p", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(serviceList), item => {
        return _openBlock(), _createElementBlock("a", {
          onClick: $event => toLink(`/service/${item.id}`),
          key: item.id
        }, _toDisplayString(item.title), 9, _hoisted_33);
      }), 128))])])])])])], 34)], 64);
    };
  }
});